import { useEffect, useState } from 'react';

export const useFetch = <T,>(url: string) => {
    const [data, setData] = useState<T | undefined>(undefined);
    const [isPending, setIsPending] = useState(false);
    const [error, setError] = useState<string | null>(null);
    useEffect(() => {
        const controller = new AbortController();
        const fetchData = async () => {
            setIsPending(true);

            try {
                const res = await fetch(url, { signal: controller.signal });

                if (!res.ok) {
                    throw new Error(res.statusText);
                }

                const json = await res.json();
                setIsPending(false);
                setData(json);
                setError(null);
            } catch (err) {
                if (err instanceof Error) {
                    if (err.name === 'AbortError') {
                        const newErrorMsg = `the fetch was aborted:  ${err.message}`;
                        setError(newErrorMsg);
                    } else {
                        setIsPending(false);
                        setError(err.message);
                    }
                }
            }
        };
        fetchData();

        return () => {
            controller.abort();
        };
    }, [url]);

    return { data, isPending, error };
};
